import { format } from 'date-fns'
import { SeItem, SeColumn } from './StyledElements.jsx'
import { formatDuration } from '../assets/assets_functions.js'
import { sailColors } from '../assets/colors.js'
import greenCheck from '../assets/green_checked.png'
import { useLang, useMobile } from '../utils/hooks.jsx'

const SailStatItem = ({ stat, onClick, isGrey, isSelected, wA }) => {
  const { lang } = useLang()
  const { mobile } = useMobile()

  let temp_bg
  let temp_cl = sailColors.itemText
  if (!isSelected && !isGrey) {
    temp_bg = sailColors.itemNotSelectedNotGreyBg
  } else if (isSelected) {
    temp_bg = sailColors.itemSelectedBg
    temp_cl = sailColors.itemTextSelected
  } else temp_bg = sailColors.itemNotSelectedGreyBg

  let i = 0
  return (
    <>
      <SeItem id={stat._id} onClick={onClick} bg={temp_bg} cl={temp_cl}>
        <SeColumn id={stat._id} w={wA[i]} align={'center'}>
          {stat.active && (
            <img src={greenCheck} style={{ width: '12px' }} alt="xx" />
          )}
        </SeColumn>
        <SeColumn id={stat._id} w={wA[++i]} align={'left'}>
          {stat.sail}
        </SeColumn>
        <SeColumn id={stat._id} w={wA[++i]} align={'center'}>
          {stat.nb}
        </SeColumn>
        <SeColumn id={stat._id} w={wA[++i]} align={'center'}>
          {formatDuration(stat.duration)}
        </SeColumn>
        {!mobile && (
          <SeColumn id={stat._id} w={wA[++i]} align={'center'}>
            {stat.firstUse !== '-'
              ? format(
                  stat.firstUse,
                  lang === 'fr' ? 'dd-MM-yyyy' : 'yyyy-MM-dd'
                )
              : stat.firstUse}
          </SeColumn>
        )}
        {!mobile && (
          <SeColumn id={stat._id} w={wA[++i]} align={'center'}>
            {stat.lastUse !== '-'
              ? format(
                  stat.lastUse,
                  lang === 'fr' ? 'dd-MM-yyyy' : 'yyyy-MM-dd'
                )
              : stat.lastUse}
          </SeColumn>
        )}
      </SeItem>
    </>
  )
}

export default SailStatItem
